export default __webpack_public_path__ + "static/media/record-mobile.3ecb7764.svg";